<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="javascript:void(0)">WhatsApp</a>
    <div class="ms-auto">
      <button class="btn btn-sm btn-outline-primary me-2" (click)="goToChat()">View Chats</button>
      <button *ngIf="status === 'connected'" class="btn btn-sm btn-outline-danger" (click)="disconnect()">Disconnect</button>
      <button *ngIf="status !== 'connected' && status !== 'initializing' && status !== 'qr_needed' && status !== 'authenticating'" class="btn btn-sm btn-outline-success" (click)="initWhatsApp()">Connect</button>
    </div>
  </div>
</nav>
<hr />

<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-md-6 col-lg-4">
      <div class="card">
        <div class="card-body text-center">

          <!-- Loading -->
          <div *ngIf="status === 'loading'">
            <div class="spinner-border text-primary mb-3" role="status"></div>
            <p class="text-muted">Checking connection status...</p>
          </div>

          <!-- Initializing -->
          <div *ngIf="status === 'initializing' || status === 'authenticating'">
            <div class="spinner-border text-success mb-3" role="status"></div>
            <p *ngIf="status === 'initializing'" class="text-muted">Initializing WhatsApp... Please wait for QR code.</p>
            <p *ngIf="status === 'authenticating'" class="text-muted">Authenticated! Loading session, please wait...</p>
          </div>

          <!-- QR Code -->
          <div *ngIf="status === 'qr_needed'">
            <h5 class="mb-3">Scan QR Code</h5>
            <p class="text-muted small">Open WhatsApp on your phone &gt; Settings &gt; Linked Devices &gt; Link a Device</p>
            <div *ngIf="qrDataUrl" class="mb-3">
              <img [src]="qrDataUrl" alt="WhatsApp QR Code" style="max-width:280px;width:100%;" />
            </div>
            <div *ngIf="!qrDataUrl">
              <div class="spinner-border text-secondary mb-3" role="status"></div>
              <p class="text-muted">Waiting for QR code...</p>
            </div>
          </div>

          <!-- Connected -->
          <div *ngIf="status === 'connected'">
            <div class="mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="#25D366" viewBox="0 0 16 16">
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326z"/>
              </svg>
            </div>
            <h5 class="text-success">Connected</h5>
            <p class="text-muted">WhatsApp is linked and receiving messages.</p>
            <button class="btn btn-outline-primary btn-sm" (click)="goToChat()">Open WhatsApp Chats</button>
          </div>

          <!-- Disconnected / Not Configured -->
          <div *ngIf="status === 'disconnected' || status === 'not_configured'">
            <div class="mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="#ccc" viewBox="0 0 16 16">
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326z"/>
              </svg>
            </div>
            <h5 class="text-muted">Not Connected</h5>
            <p class="text-muted">Click the button below to connect WhatsApp.</p>
            <button class="btn btn-success" (click)="initWhatsApp()">Connect WhatsApp</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
